import { computePosition, flip, shift } from '@floating-ui/dom'

export const selector = '.overlay-messages'

export default (el) => {
    const msgs = el
        .querySelectorAll(`${selector}-item`)

    if (!msgs)
        return

    console.groupCollapsed('Overlay Messages')

    const isMobile = window.innerWidth < 1024

    const toggleMessage = (e) => {
        const { target: btn, type } = e
        const { overlayMsg } = btn?.dataset

        const isMobileEvent = (isMobile
            && type === 'mouseenter')

        if (!overlayMsg
            || isMobileEvent)
            return

        const show = type === 'mouseenter'
            || type === 'click'

        const msg = document
            .querySelector(`#${overlayMsg}`)

        if (!show)
            setTimeout(() => {
                msg.classList.remove('d-block')
            }, isMobile
                ? 500
                : 1)

        if (show) {
            msg.classList.add('d-block')

            computePosition(btn, msg, {
                placement: 'bottom',
                middleware: [
                    flip(),
                    shift()
                ]
            }).then(({x, y}) => {
                Object.assign(msg.style, {
                    left: `${x}px`,
                    top: `${y}px`,
                })
            })
        }

        if (isMobile && type === 'click')
            e.preventDefault()
    }

    const watchLinks = (links, id) => {
        links.forEach(link => {
            const msgLink = document
                .querySelector(`#om-${id} .overlay-messages-item-link a`)

            link.setAttribute('data-overlay-msg',
                `om-${id}`)

            link.href = link.href
                .replace(`#${id}`, '')

            msgLink.href = link.href

            link.addEventListener(
                'click', toggleMessage)

            link.addEventListener(
                'mouseenter', toggleMessage)

            link.addEventListener(
                'mouseleave', toggleMessage)
        })
    }

    msgs.forEach(item => {
        const id = item.id.replace('om-', '')

        const links = Array
            .from(document.getElementsByTagName('a'))
            .filter(i => i.href.search(`#${id}`) > -1)

        if (!links)
            return

        watchLinks(links, id)
    })

    console.log(el, msgs)

    console.groupEnd()

    return el
}
